import { useEffect, useState } from "react";
import type { Device, DeviceInput, SimType } from "../api";

const empty: DeviceInput = {
  phone: "",
  serial_no: "",
  imei: "",
  sim_type: "ntc",
  label: "",
};

export function DeviceForm({
  initial,
  onSubmit,
  onCancel,
  busy,
  error,
}: {
  initial?: Device | null;
  onSubmit: (input: DeviceInput) => Promise<void>;
  onCancel: () => void;
  busy: boolean;
  error: string | null;
}) {
  const [form, setForm] = useState<DeviceInput>(empty);
  const [active, setActive] = useState(true);

  useEffect(() => {
    if (initial) {
      setForm({
        phone: initial.phone,
        serial_no: initial.serial_no,
        imei: initial.imei,
        sim_type: initial.sim_type,
        label: initial.label ?? "",
      });
      setActive(initial.is_active);
    } else {
      setForm(empty);
      setActive(true);
    }
  }, [initial]);

  return (
    <form
      className="device-form"
      onSubmit={(e) => {
        e.preventDefault();
        void onSubmit({ ...form, is_active: active, label: form.label || null });
      }}
    >
      <h3>{initial ? "Edit device" : "Add device"}</h3>
      {error && <p className="form-error">{error}</p>}
      <label>
        Label
        <input value={form.label ?? ""} onChange={(e) => setForm({ ...form, label: e.target.value })} placeholder="Bus 12 - Front" />
      </label>
      <label>
        Phone / SIM MSISDN
        <input required value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} placeholder="9801234567" />
      </label>
      <label>
        Serial no
        <input required value={form.serial_no} onChange={(e) => setForm({ ...form, serial_no: e.target.value })} />
      </label>
      <label>
        IMEI
        <input required value={form.imei} onChange={(e) => setForm({ ...form, imei: e.target.value })} />
      </label>
      <label>
        SIM type
        <select
          value={form.sim_type}
          onChange={(e) => setForm({ ...form, sim_type: e.target.value as SimType })}
        >
          <option value="ntc">NTC</option>
          <option value="ncell">Ncell</option>
        </select>
      </label>
      <label className="checkbox">
        <input type="checkbox" checked={active} onChange={(e) => setActive(e.target.checked)} />
        Active (accept GPS / video from this terminal)
      </label>
      <div className="form-actions">
        <button type="submit" disabled={busy}>
          {busy ? "Saving…" : initial ? "Save" : "Create"}
        </button>
        <button type="button" className="ghost" onClick={onCancel} disabled={busy}>
          Cancel
        </button>
      </div>
    </form>
  );
}
